import { IpaType, isTone } from "../phonemes/ipa";
import { ipaToFeatures } from "../phonemes/ipa";
import { ipaToSynthSymbols } from "../speak/exact";
import { ipaToSynth } from "../speak/ipaToSynth";
import { meSpeakOptions } from "../speak/meSpeak";
import { speakEspeak, speakPhonemes } from "../speak/speakPhonemes";

/** pronounce a single IPA segment like a, ou, b, or ts */
export function speakSegment(ipa: IpaType) {
  if (isTone(ipa)) {
    // in case tone isn't directly supported
    const { speak } = ipaToSynth(ipa);
    speakEspeak(`a${speak}`, options);
    return;
  }

  const eSpeak = ipaToSynthSymbols[ipa];
  const features = ipaToFeatures(ipa);
  if (eSpeak) {
    let phrase = '';
    if (features && features.includes('vowel') && features.includes('non-syllabic')) {
      phrase = 'a' + eSpeak;
    } else if (features && (features.includes('vowel') || features.includes('syllabic'))) {
      phrase = eSpeak + ':';
    } else {
      phrase = eSpeak + 'a';
    }
    speakEspeak("'" + phrase, options);
  } else if (ipa === 'ɹ̩') {
    speakPhonemes('ˈɝ:', options);
  } else {
    const consonantish = features && (features.includes('consonant') || features.includes('non-syllabic'));
    const phrase = consonantish ? ipa + 'a' : ipa;
    const spoken = ipa.length >= 2 && ipa[ipa.length - 1] === 'ɹ' ? `${ipa}9` : phrase;
    speakPhonemes("ˈ" + spoken, options);
  }
}

const options: meSpeakOptions = { pitch: 50, wordgap: 1, speed: 100, variant: "fiona" };
